import styled from 'styled-components';
import { Dropdown, QuantityCounter, Typography } from '@/components/atoms';
import { useTranslation } from 'react-i18next';
import { IVariantDropdownOption } from '@/types/index';
import { soldOut } from '@/utils/Product';

interface VariantDropdownProps {
  options: IVariantDropdownOption[];
  chosenVariants: { [variantId: string]: number };
  onChangeQuantity: (quantity: number, variantId: string) => void;
  onDropdownChange: (expanded: boolean) => void;
}

interface IStyledProps {
  disabled?: boolean;
}

const Wrapper = styled.div`
  border: 1px solid ${props => props.theme.paletteDefault.grey1};
  max-width: 400px;
  margin-top: 16px;
`;

const AccordionTitleTypography = styled(Typography)`
  text-transform: uppercase;
`;

const LineTypography = styled(Typography)<IStyledProps>`
  text-transform: uppercase;
  color: ${props =>
    props.disabled
      ? props.theme.paletteDefault.primary.main
      : props.theme.paletteDefault.primary.main};
`;

const LineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const VariantDropdown: React.FC<VariantDropdownProps> = props => {
  const { options, chosenVariants, onChangeQuantity, onDropdownChange } = props;
  const { t } = useTranslation('product');

  const AccordionTitle = (
    <AccordionTitleTypography className="smalltitle">
      {t('choose-sizes')}
    </AccordionTitleTypography>
  );

  return (
    <Wrapper>
      <Dropdown
        header={AccordionTitle}
        onChange={(_, expanded) => onDropdownChange(expanded)}>
        {options.length > 0 ? (
          options.map(item => (
            <LineWrapper key={item.variant_id}>
              <LineTypography
                className="smalltitle"
                disabled={soldOut(
                  item.currentlyNotInStock,
                  item.quantityAvailable
                )}>
                {item.variant_options?.size}
              </LineTypography>
              {soldOut(item.currentlyNotInStock, item.quantityAvailable) ? (
                <LineTypography className="smalltitle" disabled>
                  {t('sold-out')}
                </LineTypography>
              ) : (
                <QuantityCounter
                  debounce={false}
                  minValue={0}
                  quantity={chosenVariants[item.variant_id] ?? 1}
                  template="medium"
                  changeQuantityHandler={e =>
                    onChangeQuantity(e, item.variant_id)
                  }
                />
              )}
            </LineWrapper>
          ))
        ) : (
          <p>{t('no-extra-option-selected')}</p>
        )}
      </Dropdown>
    </Wrapper>
  );
};

export default VariantDropdown;
